import React, { useCallback, useEffect, useRef, useState } from "react";
import "../../assets/styles/Search.css";
import "../../assets/styles/Profile.css";
import Popup from "reactjs-popup";
import { motion } from "framer-motion";
import Header from "../../components/Header.js";
import InfoUser from "../../components/Profile/InfoUser.js";
import DataConfirm from "../../components/Profile/DataConfirm.js";
import HtmlNote from "../../components/Profile/HtmlNote.js";
import Collapsible from "react-collapsible";
import Swal from "sweetalert2";
import iconSearch from "../../icons/icon-search.png";
import { useLocation, useNavigate } from "react-router-dom";
import Loading from "../../components/helper/Loading.js";
import { config } from "../../config.js";
import { apiCheckAccount, apiGetSetting, apiGetBanks } from "../../services/api.service.js";
import {
  apiConfirmUpdate,
  apiUpdateAccount,
  apiCheckDataAccount,
  apiFormUpdateAccount,
  apiGetRequestHistory,
} from "../../services/api.service.js";
// import iconArrow from "../../icons/";
import {
  Box,
  Button,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Typography,
  IconButton,
} from "@mui/material";
import { AddPhotoAlternateOutlined, Close } from "@mui/icons-material";
import iconArrow from "../../icons/icon-arrow.png";
import iconSendMail from "../../icons/icon-send-mail.png";
import iconSendPhone from "../../icons/icon-send-phone.png";
import iconImage from "../../icons/icon-image.png";
import iconClose from "../../icons/icon-close.png";
import iconWarning from "../../icons/icon-warning.png";
import iconSuccess from "../../icons/icon-success.png";

function ChangeInfo() {
  const location = useLocation();
  const { userName, data, webSetting, typeModal } = location.state || {};

  // quên mật khẩu: khách chọn lấy lại mật khẩu đăng nhập (forget_password) hoặc mật khẩu rút tiền (forget_password_withdraw)
  // loại bị giới hạn (disabled_update_types) thì không cho chọn
  const disabledUpdateTypes = data?.disabled_update_types || [];
  const forgetPasswordOptions = [
    { value: "forget_password", label: "Quên mật khẩu đăng nhập", content: "Lấy mật khẩu đăng nhập" },
    { value: "forget_password_withdraw", label: "Quên mật khẩu rút tiền", content: "Lấy mật khẩu rút tiền" },
  ].filter((item) => !disabledUpdateTypes.includes(item.value));
  const [forgetPasswordType, setForgetPasswordType] = useState("");
  // loại yêu cầu gửi lên BE (quên mật khẩu thì theo lựa chọn của khách)
  const requestType = typeModal === "forget_password" ? forgetPasswordType : typeModal;

  // mô tả file upload và số ảnh tối thiểu theo mục thông tin khách đang chọn (setup ở admin)
  const uploadSetting = webSetting?.upload_descriptions || {};
  const uploadConfig = uploadSetting.by_update_type?.[requestType] || {};
  const uploadDescriptions = [];
  (uploadConfig.keys || []).forEach((key) => {
    const item = (uploadSetting.items || []).find((item) => item.key === key);
    if (item?.content) uploadDescriptions.push(item.content);
  });
  const minFiles = uploadConfig.min_files ?? 2; // chưa setup thì mặc định 2 ảnh

  const [openResult, setOpenResult] = useState(false);
  const [checkConfirm, setCheckConfirm] = useState(false);
  const [isSendMail, setIsSendMail] = useState(true);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openUploadFile, setOpenUploadFile] = useState(false);
  const [previews, setPreviews] = useState([]);
  const [selectedImage, setSelectedImage] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [infoFileUpload, setInfoFileUpload] = useState("");
  const [submittedRequest, setSubmittedRequest] = useState(null);
  const [pollingChecks, setPollingChecks] = useState(0);
  const [isRefreshingRequest, setIsRefreshingRequest] = useState(false);
  const [requestRefreshMessage, setRequestRefreshMessage] = useState("");
  const initialStatusCheckedCodeRef = useRef("");
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [banks, setBanks] = useState([]); // danh sách ngân hàng cho khách chọn
  const originalDataUpdate = {
    bank_type_change: "",
    name: "",
    province: "",
    bank_name: "",
    bank_number: "",
    province: "",
    email: "",
    phone_number: "",
  };
  const originalDesChangeUsdt = {
    title_change_bank: "THAY ĐỔI THÔNG TIN VÍ USDT",
    bank_name: "Hệ Ví USDT Mới",
    bank_number: "Số Ví USDT Mới",
  };
  const [desChangeUsdt, setDesChangeUsdt] = useState(originalDesChangeUsdt);

  const [dataUpdate, setDataUpdate] = useState(originalDataUpdate);
  const bankFieldSuffix = dataUpdate.bank_type_change === "Xóa số tài khoản" ? "Cần Xóa" : "Mới";
  const [timesCheckData, setTimesCheckData] = useState(0);
  const [dataCheck, setDataCheck] = useState({
    name: "",
    province: "",
    bank_name: "",
    bank_number: "",
    email: "",
    phone_number: "",
  });

  const [user, setUser] = useState({
    account: userName,
    update_type: "",
    status: "",
    auto_check: "",
    send_type: "",
  });

  const mergeRequestStatus = useCallback((request) => {
    setSubmittedRequest((currentRequest) => currentRequest ? {
      ...currentRequest,
      ...request,
      request_code: request.request_code || currentRequest.request_code,
      send_type: request.send_type || currentRequest.send_type,
      update_type: request.update_type || currentRequest.update_type,
    } : request);
  }, []);

  useEffect(() => {
    const requestCode = submittedRequest?.request_code;
    if (!openConfirm || !requestCode || initialStatusCheckedCodeRef.current === requestCode) return undefined;
    initialStatusCheckedCodeRef.current = requestCode;
    let isActive = true;
    const checkInitialStatus = async () => {
      const result = await apiGetRequestHistory(userName, requestCode);
      if (!isActive) return;
      if (result?.code === 200 && result?.data?.request) {
        mergeRequestStatus(result.data.request);
        setRequestRefreshMessage("");
      }
      else setRequestRefreshMessage("Chưa thể cập nhật trạng thái. Hệ thống sẽ tự động kiểm tra lại sau 30 giây.");
    };
    checkInitialStatus();
    return () => {
      isActive = false;
    };
  }, [mergeRequestStatus, openConfirm, submittedRequest?.request_code, userName]);

  useEffect(() => {
    if (!openConfirm || !submittedRequest?.request_code || submittedRequest.status !== "no_process" || pollingChecks >= 15) return undefined;
    const intervalId = setInterval(async () => {
      const result = await apiGetRequestHistory(userName, submittedRequest.request_code);
      setPollingChecks((count) => count + 1);
      if (result?.code === 200 && result?.data?.request) {
        mergeRequestStatus(result.data.request);
        setRequestRefreshMessage("");
      }
    }, 30 * 1000);
    return () => clearInterval(intervalId);
  }, [mergeRequestStatus, openConfirm, submittedRequest?.request_code, submittedRequest?.status, pollingChecks, userName]);

  const refreshSubmittedRequest = async () => {
    if (isRefreshingRequest || !submittedRequest?.request_code) return;
    setIsRefreshingRequest(true);
    setRequestRefreshMessage("");
    const result = await apiGetRequestHistory(userName, submittedRequest.request_code);
    if (result?.code === 200 && result?.data?.request) {
      mergeRequestStatus(result.data.request);
      setRequestRefreshMessage(`Đã cập nhật trạng thái mới nhất lúc ${new Date().toLocaleTimeString("vi-VN")}`);
    } else setRequestRefreshMessage("Không thể cập nhật trạng thái. Vui lòng thử lại.");
    setIsRefreshingRequest(false);
  };

  const copySubmittedRequestCode = async () => {
    try {
      await navigator.clipboard.writeText(submittedRequest?.request_code || "");
      setRequestRefreshMessage(`Đã sao chép: ${submittedRequest?.request_code}`);
    } catch (error) {
      setRequestRefreshMessage("Không thể sao chép mã yêu cầu.");
    }
  };

  const inputDataCheck = (event) => {
    const { name, value } = event.target;
    setDataCheck({
      ...dataCheck,
      [name]: value,
    });
  };

  const inputDataUpdate = (event) => {
    const { name, value } = event.target;
    setDataUpdate({
      ...dataUpdate,
      [name]: value,
    });
  };

  useEffect(() => {
    const fetchBanks = async () => {
      setBanks(await apiGetBanks());
    };
    fetchBanks();
  }, []);

  // chọn ngân hàng: lưu mã ngân hàng (bank_code) và tên ngân hàng (bank_name)
  const selectBankCheck = (event) => {
    const bank = banks.find((item) => item.code === event.target.value);
    setDataCheck({
      ...dataCheck,
      bank_code: bank ? bank.code : "",
      bank_name: bank ? bank.name : "",
    });
  };

  const selectBankUpdate = (event) => {
    const bank = banks.find((item) => item.code === event.target.value);
    setDataUpdate({
      ...dataUpdate,
      bank_code: bank ? bank.code : "",
      bank_name: bank ? bank.name : "",
    });
  };
  let contentUpdate;

  useEffect(() => {
    updateUserField("update_type", typeModal);
  }, []);

  const selectForgetPasswordType = (event) => {
    const value = event.target.value;
    setForgetPasswordType(value);
    updateUserField("update_type", value || typeModal);
  };

  const validateForm = (sendType = "", checkData = dataCheck) => {
    let errors = {};
    let formIsValid = true;

    // Kiểm tra trường Name
    if (!checkData.name) {
      formIsValid = false;
      errors.name = "Vui lòng nhập Họ và Tên";
    }

    // Kiểm tra trường phone_number
    if (sendType === "phone_number" && data.phone_number) {
      if (!checkData.phone_number) {
        formIsValid = false;
        errors.phone_number = "Vui lòng nhập Số Điện Thoại";
      } else if (!/^\d{10}$/.test(checkData.phone_number)) {
        formIsValid = false;
        errors.phone_number = "Số Điện Thoại không hợp lệ";
      }
    }

    // Kiểm tra trường email
    if ((sendType === "mail" || sendType === "email") && data.email) {
      if (!checkData.email) {
        formIsValid = false;
        errors.email = "Vui lòng nhập Email";
      } else if (!/\S+@\S+\.\S+/.test(checkData.email)) {
        formIsValid = false;
        errors.email = "Email không hợp lệ";
      }
    }

    // Kiểm tra trường bank_name
    if (!checkData.bank_name) {
      formIsValid = false;
      errors.bank_name = "Vui lòng chọn Ngân Hàng";
    }

    // Kiểm tra trường bank_number
    if (!checkData.bank_number) {
      formIsValid = false;
      errors.bank_number = "Vui lòng nhập Số Tài Khoản";
    }
    switch (typeModal) {
      case "full_name": // Kiểm tra trường Name update
        if (!dataUpdate.name) {
          formIsValid = false;
          errors.nameUpdate = "Vui lòng nhập Họ và Tên mới";
        } else {
          contentUpdate = dataUpdate.name;
        }
        break;
      case "phone_number": // Kiểm tra trường phone_number
        if (!dataUpdate.phone_number) {
          formIsValid = false;
          errors.phoneNumberUpdate = "Vui lòng nhập Số Điện Thoại mới";
        } else if (!/^\d{10}$/.test(dataUpdate.phone_number)) {
          formIsValid = false;
          errors.phoneNumberUpdate = "Số Điện Thoại mới không hợp lệ";
        } else {
          contentUpdate = dataUpdate.phone_number;
        }
        break;
      case "email": // Kiểm tra trường email
        if (!dataUpdate.email) {
          formIsValid = false;
          errors.emailUpdate = "Vui lòng nhập Email mới";
        } else if (!/\S+@\S+\.\S+/.test(dataUpdate.email)) {
          formIsValid = false;
          errors.emailUpdate = "Email mới không hợp lệ";
        } else {
          contentUpdate = dataUpdate.email;
        }
        break;
      case "bank": // Kiểm tra value bank
        if (!dataUpdate.bank_type_change) {
          formIsValid = false;
          errors.bankTypeChange = "Vui lòng chọn yêu cầu thay đổi";
        }
        if (!dataUpdate.bank_name) {
          formIsValid = false;
          errors.bankNameUpdate = `Vui lòng chọn Ngân Hàng ${bankFieldSuffix}`;
        }
        if (!dataUpdate.bank_number) {
          formIsValid = false;
          errors.bankNumberUpdate = `Vui lòng nhập Số Tài Khoản ${bankFieldSuffix}`;
        } else {
          contentUpdate =
            dataUpdate.bank_type_change +
            " - " +
            dataUpdate.bank_number +
            " - " +
            dataUpdate.bank_name +
            " - " +
            dataUpdate.province;
        }
        if (!dataUpdate.province) {
          formIsValid = false;
          errors.province = `Vui lòng nhập chi nhánh Ngân Hàng ${bankFieldSuffix}`;
        }
        break;
      case "usdt": // Kiểm tra value bank
        if (!dataUpdate.bank_type_change) {
          formIsValid = false;
          errors.bankTypeChange = "Vui lòng chọn yêu cầu thay đổi";
        }
        if (!dataUpdate.bank_name) {
          formIsValid = false;
          errors.bankNameUpdate = "Vui lòng chọn Ví mới";
        }
        if (!dataUpdate.bank_number) {
          formIsValid = false;
          errors.bankNumberUpdate = "Vui lòng nhập Ví mới";
        } else {
          contentUpdate =
            dataUpdate.bank_type_change +
            " - " +
            dataUpdate.bank_number +
            " - " +
            dataUpdate.bank_name;
        }
        break;
      case "birthday": // Kiểm tra trường birth day
        if (!dataUpdate.birth_day) {
          formIsValid = false;
          errors.birthDayUpdate = "Vui lòng chọn ngày tháng năm sinh";
        } else {
          contentUpdate = dataUpdate.birth_day;
        }
        break;
      case "forget_password": // quên mật khẩu: bắt buộc chọn mật khẩu đăng nhập hoặc mật khẩu rút tiền
        if (!forgetPasswordType) {
          formIsValid = false;
          errors.forgetPasswordType = "Vui lòng chọn mật khẩu cần lấy lại";
        } else {
          contentUpdate = forgetPasswordOptions.find((item) => item.value === forgetPasswordType)?.content;
        }
        break;
      case "other_note": // CSKH xác minh: bắt buộc nhập ghi chú
        if (!checkData.note?.trim()) {
          formIsValid = false;
          errors.note = "Bạn vui lòng điền thông tin cần xác minh hỗ trợ liên quan vào mục ghi chú.";
        }
        break;
      default:
        break;
    }
    console.log(errors);
    setErrors(errors);
    return formIsValid;
  };
  const modalConfirmUpdate = async (type) => {
    if (!validateForm()) return;
    if (type === "files" || (type === "auto_confirm" && typeModal === "birthday")) {
      updateUser(type);
      return;
    }

    const isEmail = type === "mail";
    const result = await Swal.fire({
      icon: "warning",
      title: isEmail
        ? "Vui lòng nhập Email đã liên kết"
        : "Vui lòng nhập Số Điện Thoại đã liên kết",
      input: isEmail ? "email" : "text",
      inputValue: isEmail ? dataCheck.email : dataCheck.phone_number,
      inputPlaceholder: isEmail ? "Email" : "Số Điện Thoại",
      showCancelButton: true,
      confirmButtonText: "Tiếp tục",
      cancelButtonText: "Quay lại",
      reverseButtons: true,
      inputValidator: (value) => {
        const normalizedValue = isEmail
          ? value.trim()
          : value.trim().replace(/^(\+?84)/, "0");

        if (!normalizedValue) {
          return isEmail
            ? "Vui lòng nhập Email"
            : "Vui lòng nhập Số Điện Thoại";
        }
        if (isEmail && !/\S+@\S+\.\S+/.test(normalizedValue)) {
          return "Email không hợp lệ";
        }
        if (!isEmail && !/^\d{10}$/.test(normalizedValue)) {
          return "Số Điện Thoại không hợp lệ";
        }
        return undefined;
      },
    });

    if (result.isConfirmed) {
      const value = isEmail
        ? result.value.trim()
        : result.value.trim().replace(/^(\+?84)/, "0");
      const nextDataCheck = {
        ...dataCheck,
        [isEmail ? "email" : "phone_number"]: value,
      };
      setDataCheck(nextDataCheck);
      updateUser(type, nextDataCheck);
    }
  };

  const updateUserField = (field, value) => {
    setUser((prevUser) => ({
      ...prevUser,
      [field]: value,
    }));
  };

  const openModalConfirm = (type) => {
    setOpenConfirm(true);
  };
  const confirmUpdateUser = async (body, type) => {
    setLoading(true);
    let updateInfo = await apiFormUpdateAccount(body, type === "auto_confirm" ? [] : selectedFiles);
    setLoading(false);
    if (updateInfo) {
      const requestCode = updateInfo?.request_code;
      if (!requestCode) {
        return Swal.fire({ icon: "error", text: "Không nhận được mã yêu cầu. Vui lòng thử lại." });
      }
      const newRequest = {
        ...updateInfo,
        request_code: requestCode,
        status: updateInfo.status || "no_process",
        verification_status: updateInfo.verification_status || (["email", "phone_number"].includes(user.send_type) ? "not_received" : "success"),
        send_type: user.send_type,
        update_type: user.update_type,
      };
      setUser((current) => ({ ...current, request_code: requestCode }));
      setSubmittedRequest(newRequest);
      setPollingChecks(0);
      setRequestRefreshMessage("");
      openModalConfirm(type);
    }
  };
  const updateUser = async (type, checkData = dataCheck) => {
    if (validateForm(type, checkData)) {
      if (type === "mail") {
        user.send_type = "email";
        setIsSendMail(true);
      } else if (type === "phone_number") {
        user.send_type = "phone_number";
        setIsSendMail(false);
      } else if (type === "files") {
        user.send_type = "files";
        updateUserField("send_type", "files");
        setIsSendMail(false);
      } else if (type === "auto_confirm" && typeModal === "birthday") {
        user.send_type = "auto_confirm";
        updateUserField("send_type", "auto_confirm");
        setIsSendMail(false);
      }
      let body = {
        ...user,
        data_check: {
          ...checkData,
        },
        data_update: {
          update_type: user.update_type,
          content: contentUpdate,
          // đổi ngân hàng: gửi thêm mã ngân hàng + số tài khoản để BE không phải tách từ content
          ...(user.update_type === "bank" && {
            bank_code: dataUpdate.bank_code,
            bank_number: dataUpdate.bank_number,
          }),
        },
      };
      setLoading(true);
      let checkDataOld = await apiCheckDataAccount(body);
      setLoading(false);
      if (checkDataOld) {
        if (type === "files" && selectedImage.length === 0) {
          let descriptionFileUpload = uploadDescriptions.length > 0
            ? "Bạn vui lòng tải lên ít nhất " + minFiles + " trong " + uploadDescriptions.length + " hình ảnh dưới để xác minh tài khoản<br/><br/>"
            : "Bạn vui lòng tải lên ít nhất " + minFiles + " hình ảnh để xác minh tài khoản<br/><br/>";
          uploadDescriptions.forEach((element, index) => {
            descriptionFileUpload += (index + 1) + ". " + element + "</br>";
          });
          descriptionFileUpload = "<p>" + descriptionFileUpload + "</p>";
          setInfoFileUpload(descriptionFileUpload);
          setOpenUploadFile(true);
          return;
        }
        let confirmUpdate = checkDataOld.result;
        let value_auto_check = confirmUpdate ? "check_success" : "check_fail";
        updateUserField("auto_check", value_auto_check);
        body.auto_check = value_auto_check;
        //nếu thông tin đúng hết hoặc đã nhập lại từ 5 lần và có số điện thoại hoặc email đúng thì tự động confirm gửi yêu cầu
        if (timesCheckData >= 100 && checkDataOld.allowSubmit > 0) {
          confirmUpdateUser(body, type);
        } else {
          const verificationError =
            type === "phone_number" && checkDataOld.submitPhoneNumber === 0
              ? "Quý khách nhập không đúng SĐT đã liên kết, vui lòng kiểm tra lại thông tin hoặc sử dụng cách khác."
              : type === "mail" && checkDataOld.submitEmail === 0
                ? "Quý khách nhập không đúng Email đã liên kết, vui lòng kiểm tra lại thông tin hoặc sử dụng cách khác."
                : "";
          if (!verificationError) {
            confirmUpdateUser(body, type);
            return;
          }
          setLoading(false);
          Swal.fire({
            icon: "warning",
            title: "Chú ý",
            text: verificationError,
            showCancelButton: true,
            cancelButtonText: "Nhập lại",
            confirmButtonText: "Tiếp tục gửi",
            showConfirmButton:
              type === "files" ||
              (type === "phone_number" && checkDataOld.submitPhoneNumber === 1) ||
              (type === "mail" && checkDataOld.submitEmail === 1),
            reverseButtons: true,
          }).then((result) => {
            if (result.isConfirmed) {
              confirmUpdateUser(body, type);
            } else if (result.isDismissed) {
              setTimesCheckData((currentTimes) => currentTimes + 1);
              if (type === "mail" || type === "phone_number") modalConfirmUpdate(type);
            }
          });
        }
      }
    }
  };
  const closeModalConfirm = () => {
    setOpenConfirm(false);
    const recentRequests = submittedRequest
      ? [submittedRequest, ...(data?.recent_requests || []).filter((item) => item.request_code !== submittedRequest.request_code)].slice(0, 2)
      : (data?.recent_requests || []).slice(0, 2);
    navigate("/profile", { state: { userName, data: { ...data, recent_requests: recentRequests }, webSetting } });
  };

  const handleImageUpload = async (event) => {
    const files = Array.from(event.target.files);
    const validFiles = files.filter((file) => {
      if (file.size > 30 * 1024 * 1024) {
        Swal.fire({
          icon: "error",
          title: "Thất bại!",
          text: `${file.name} vượt quá giới hạn 30MB.`,
        });
        return false;
      }
      return true;
    });

    setSelectedFiles((prevFiles) => [...prevFiles, ...validFiles]);
    // const newPreviews = validFiles.map((file) => URL.createObjectURL(file));
    const newPreviews = validFiles.map((file) => ({
      url: URL.createObjectURL(file),
      type: file.type,
    }));
    if (previews.length + newPreviews.length > 7) {
      Swal.fire({
        icon: "error",
        title: "Thất bại!",
        text: "Hệ thống yêu cầu tối đa 7 file",
      });
      return;
    }
    // const base64Images = await Promise.all(
    const base64Files = await Promise.all(
      validFiles.map((file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
        });
      })
    );
    setPreviews((prevPreviews) => [...prevPreviews, ...newPreviews]);
    setSelectedImage((prevImages) => [...prevImages, ...base64Files]);
  };

  const handleRemoveImage = (index) => {
    setPreviews((prevPreviews) => prevPreviews.filter((_, i) => i !== index));
    setSelectedImage((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  return (
    <div className="container">
      {loading && <Loading loading={loading} />}
      <motion.div
        className="app"
        initial={{ x: "100vw", opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: "-100vw", opacity: 0 }}
        transition={{
          type: "spring",
          stiffness: 1000,
          damping: 200,
          duration: 10,
        }}
      >
        <Header
          isPageSearch={false}
          pageToAcction={"/profile"}
          data={{ userName, data, webSetting }}
        />

        <div className="content">
          {/* <Popup open={open} onClose={() => {setOpen(false); document.body.style.overflow = 'auto';}} position={"center"} closeOnDocumentClick={false} nested> */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
            id="modal-info"
            className="modal-info"
          >
            <div className="info-current">
              <Collapsible
                open={false}
                trigger={[
                  "GỢI Ý THÔNG TIN ĐÃ LIÊN KẾT",
                  <img src={iconArrow} key="icon-arrow" alt="icon-arrow" />,
                ]}
              >
                <InfoUser />
              </Collapsible>
            </div>
            <div className="confirm-info-old">
              <span className="modal-titlte">
                VUI LÒNG NHẬP LẠI THÔNG TIN ĐÃ LIÊN KẾT
              </span>
              <div className="input-info">
                <input
                  type="text"
                  name="name"
                  value={dataCheck.name}
                  onChange={inputDataCheck}
                  placeholder="Họ Và Tên"
                />
                {errors.name && <p className="error">{errors.name}</p>}
                <select name="bank_code" value={dataCheck.bank_code || ""} onChange={selectBankCheck}>
                  <option value="">Chọn Ngân Hàng</option>
                  {banks.map((bank) => (
                    <option key={bank.code} value={bank.code}>
                      {bank.name}
                    </option>
                  ))}
                </select>
                {errors.bank_name && (
                  <p className="error">{errors.bank_name}</p>
                )}
                <input
                  type="text"
                  name="bank_number"
                  value={dataCheck.bank_number}
                  onChange={inputDataCheck}
                  placeholder="Số Tài Khoản"
                />
                {errors.bank_number && (
                  <p className="error">{errors.bank_number}</p>
                )}
                <textarea
                  name="note"
                  value={dataCheck.note}
                  onChange={inputDataCheck}
                  placeholder="Ghi chú khác nếu có"
                  rows={2}
                />
                {errors.note && (
                  <p className="error">{errors.note}</p>
                )}
              </div>
            </div>
            <div className="confirm-info-new">
              <span className="modal-titlte">{({forget_password: "QUÊN MẬT KHẨU", other_note: " " }[typeModal])||"THAY ĐỔI THÔNG TIN MỚI"}</span>
              {
                {
                  forget_password: (
                    <div className="input-info">
                      <select name="forget_password_type" value={forgetPasswordType} onChange={selectForgetPasswordType}>
                        <option value="">Chọn mật khẩu cần lấy lại</option>
                        {forgetPasswordOptions.map((item) => (
                          <option key={item.value} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                      {errors.forgetPasswordType && (
                        <p className="error">{errors.forgetPasswordType}</p>
                      )}
                    </div>
                  ),
                  full_name: (
                    <div className="input-info">
                      <input
                        type="text"
                        name="name"
                        onChange={inputDataUpdate}
                        placeholder="Họ Tên Mới"
                      />
                      {errors.nameUpdate && (
                        <p className="error">{errors.nameUpdate}</p>
                      )}
                    </div>
                  ),
                  phone_number: (
                    <div className="input-info">
                      <input
                        type="text"
                        name="phone_number"
                        onChange={inputDataUpdate}
                        placeholder="Số Điện Thoại Mới"
                      />
                      {errors.phoneNumberUpdate && (
                        <p className="error">{errors.phoneNumberUpdate}</p>
                      )}
                    </div>
                  ),
                  email: (
                    <div className="input-info">
                      <input
                        type="text"
                        name="email"
                        onChange={inputDataUpdate}
                        placeholder="Email Mới"
                      />
                      {errors.emailUpdate && (
                        <p className="error">{errors.emailUpdate}</p>
                      )}
                    </div>
                  ),
                  bank: (
                    <div className="input-info">
                      <select
                        name="bank_type_change"
                        value={dataUpdate.bank_type_change}
                        onChange={inputDataUpdate}
                      >
                        <option value="">Chọn yêu cầu thay đổi</option>
                        {config.LIST_REQUEST_BANK.map((request) => (
                          <option key={request} value={request}>
                            {request}
                          </option>
                        ))}
                      </select>
                      {errors.bankTypeChange && (
                        <p className="error">{errors.bankTypeChange}</p>
                      )}
                      <select name="bank_code" value={dataUpdate.bank_code || ""} onChange={selectBankUpdate}>
                        <option value="">{`Chọn Ngân Hàng ${bankFieldSuffix}`}</option>
                        {banks.map((bank) => (
                          <option key={bank.code} value={bank.code}>
                            {bank.name}
                          </option>
                        ))}
                      </select>
                      {errors.bankNameUpdate && (
                        <p className="error">{errors.bankNameUpdate}</p>
                      )}
                      <input
                        type="text"
                        name="bank_number"
                        onChange={inputDataUpdate}
                        placeholder={`Số Tài Khoản Ngân Hàng ${bankFieldSuffix}`}
                      />
                      {errors.bankNumberUpdate && (
                        <p className="error">{errors.bankNumberUpdate}</p>
                      )}
                      <input
                        type="text"
                        name="province"
                        onChange={inputDataUpdate}
                        placeholder={`Chi Nhánh Ngân Hàng ${bankFieldSuffix}`}
                      />
                      {errors.province && (
                        <p className="error">{errors.province}</p>
                      )}
                    </div>
                  ),
                  birthday: (
                    <div className="input-info">
                      <input
                        type="date"
                        name="birth_day"
                        onChange={inputDataUpdate}
                        placeholder="ngày tháng năm sinh"
                        defaultValue="2000-12-01"
                      />
                      {errors.birthDayUpdate && (
                        <p className="error">{errors.birthDayUpdate}</p>
                      )}
                    </div>
                  ),
                  usdt: (
                    <div className="input-info">
                      <select
                        type="input"
                        name="bank_type_change"
                        onChange={inputDataUpdate}
                      >
                        <option value="">Chọn yêu cầu thay đổi</option>
                        {config.LIST_REQUEST_USDT.map((bank, index) => (
                          <option key={index} value={bank}>
                            {bank}
                          </option>
                        ))}
                      </select>
                      {errors.bankTypeChange && (
                        <p className="error">{errors.bankTypeChange}</p>
                      )}
                      <select name="bank_name" onChange={inputDataUpdate}>
                        <option value="">Chọn Ví Mới</option>
                        {config.LIST_USDT_WALLET.map((wallet, index) => (
                          <option key={index} value={wallet}>
                            {wallet}
                          </option>
                        ))}
                      </select>
                      {errors.bankNameUpdate && (
                        <p className="error">{errors.bankNameUpdate}</p>
                      )}
                      <input
                        type="text"
                        name="bank_number"
                        onChange={inputDataUpdate}
                        placeholder={desChangeUsdt.bank_number}
                      />
                      {errors.bankNumberUpdate && (
                        <p className="error">{errors.bankNumberUpdate}</p>
                      )}
                    </div>
                  ),
                }[typeModal]
              }
            </div>
            <div className="mode-verify">
              <span className="modal-titlte">
                VUI LÒNG LỰA CHỌN HÌNH THỨC GỬI XÁC THỰC
              </span>
              {(
                typeModal === "birthday" || 
                ( 
                  typeModal === "forget_password" &&
                  !data.email &&
                  !data.phone_number &&
                  !data.bank_number
                )
              ) && (
                <div className="action-verify-container">
                  <button
                    type="button"
                    onClick={() => modalConfirmUpdate("auto_confirm")}
                    className="action-verify-btn"
                    disabled={loading}
                  >
                    XÁC NHẬN HOÀN THÀNH
                  </button>
                </div>
              )}
              {typeModal !== "birthday" && (
                <>
                  <div className="action-verify-container">
                    {data.email && typeModal !== "usdt" && (
                      <button
                        onClick={() => modalConfirmUpdate("mail")}
                        className="action-verify-btn"
                      >
                        <img src={iconSendMail} alt="icon-bank" />
                        &nbsp; XÁC THỰC EMAIL
                      </button>
                    )}
                    {data.phone_number && (
                      <button
                        onClick={() => modalConfirmUpdate("phone_number")}
                        className="action-verify-btn"
                      >
                        <img src={iconSendPhone} alt="icon-bank" />
                        &nbsp; XÁC THỰC SĐT
                      </button>
                    )}
                  </div>
                  <p className="note-verify-image">
                    Nếu quý khách không có {typeModal !== "usdt" ? "email hoặc SDT" : "SDT"} để gửi thông tin, vui
                    lòng nhấn nút dưới đây để thực hiện thay thế
                  </p>
                </>
              )}
              <div className="action action-verify">
                <button
                  id="confirm_files_btn"
                  onClick={() => modalConfirmUpdate("files")}
                >
                  <img src={iconImage} alt="icon-bank" />
                  &nbsp;&emsp; TẢI LÊN HÌNH ẢNH THAY THẾ XÁC THỰC
                </button>
              </div>
            </div>
          </motion.div>
          {/* </Popup> */}
          <Popup
            open={openConfirm}
            closeOnDocumentClick={false}
            onClose={closeModalConfirm}
            position={"center"}
            nested
          >
            <motion.div
              initial={{ opacity: 0, y: 75 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              id="modal-confirm"
              className="modal-confirm"
            >
              <div className="modal-close">
                <a className="icon-close" onClick={closeModalConfirm}>
                  <img src={iconClose} alt="icon-close" />
                </a>
              </div>
              <div className="modal-confirm-content">
                  {isSendMail ? (
                    <p>
                      Vui lòng sử dụng email đã liên kết{" "}
                      <span style={{ color: "green" }}>{dataCheck.email}</span>, gửi
                      tin nhắn tới email Jun88{" "}
                      <span style={{ color: "red" }}>
                        {webSetting.email || "Jun88pb2@gmail.com"}
                      </span>
                      , với nội dung:
                    </p>
                  ) : user.send_type === "phone_number" ? (
                    <p>
                      Vui lòng sử dụng số điện thoại đã liên kết
                      <span style={{ color: "green" }}>
                        {" " + dataCheck.phone_number}
                      </span>
                      , gửi tin nhắn tới số điện thoại Jun88{" "}
                      <span style={{ color: "red" }}>
                        {webSetting.phone_number || "+84708999988"}
                      </span>
                      , với nội dung:
                    </p>
                  ) : (
                    <p>
                      Jun88 đã ghi nhận yêu cầu của quý khách. Vui lòng đợi xét duyệt.
                    </p>
                  )}
                  <DataConfirm
                    user={user}
                    dataCheck={dataCheck}
                    dataUpdate={dataUpdate}
                    webSetting={webSetting}
                  />
                  {submittedRequest && (
                    <div className={`request-processing-status status-${submittedRequest.status} verification-${submittedRequest.verification_status || "success"}`}>
                      {submittedRequest.status === "no_process" && (
                        <div className={`request-live-update-notice ${pollingChecks >= 15 ? "request-live-update-stopped" : ""}`} role="status" aria-live="polite">
                          {pollingChecks < 15 ? <span className="request-loading-icon" aria-hidden="true" /> : <span className="request-update-paused-icon" aria-hidden="true">✓</span>}
                          <div>
                            <strong>{pollingChecks < 15 ? "Hệ thống đang tự động cập nhật trạng thái" : "Đã hoàn tất kiểm tra tự động"}</strong>
                            <small>{pollingChecks < 15 ? "Vui lòng giữ màn hình này mở và chờ kết quả xử lý." : "Bạn có thể bấm Kiểm tra lại để lấy trạng thái mới nhất."}</small>
                          </div>
                        </div>
                      )}
                      <h3 className="request-processing-title">
                        {submittedRequest.status === "approved" ? "Yêu cầu đã xử lý thành công"
                          : submittedRequest.status === "removed" ? "Yêu cầu đã bị từ chối"
                            : ["email", "phone_number"].includes(submittedRequest.send_type) && submittedRequest.verification_status !== "success"
                              ? "Yêu cầu đang chờ xác thực" : pollingChecks < 15 ? "Yêu cầu đang được xử lý" : "Yêu cầu đang được xử lý lâu hơn dự kiến"}
                      </h3>
                      {(submittedRequest.note || submittedRequest.result) && <div className="request-result-note"><strong>Kết quả xử lý:</strong><HtmlNote html={submittedRequest.note || submittedRequest.result} /></div>}
                      <div className="request-progress">
                        <div className="request-progress-step step-complete"><span>1</span><small>Đã gửi yêu cầu</small></div>
                        <div className={`request-progress-step ${!["email", "phone_number"].includes(submittedRequest.send_type) || submittedRequest.verification_status === "success" ? "step-complete" : submittedRequest.verification_status === "invalid" ? "step-error" : "step-current"}`}><span>2</span><small>{["email", "phone_number"].includes(submittedRequest.send_type) ? "Xác thực" : "Đã tiếp nhận"}</small></div>
                        <div className={`request-progress-step ${submittedRequest.status === "approved" ? "step-complete" : submittedRequest.status === "removed" ? "step-error" : ["email", "phone_number"].includes(submittedRequest.send_type) && submittedRequest.verification_status !== "success" ? "step-pending" : "step-current"}`}><span>3</span><small>Đang xử lý</small></div>
                        <div className={`request-progress-step ${submittedRequest.status === "approved" ? "step-complete" : submittedRequest.status === "removed" ? "step-error" : "step-pending"}`}><span>4</span><small>Hoàn tất</small></div>
                      </div>
                      {submittedRequest.status === "no_process" && <div className="request-processing-message">
                        {submittedRequest.verification_status === "not_received" && submittedRequest.send_type === "email" && <p>Chưa nhận xác thực. Vui lòng gửi từ email đã liên kết.</p>}
                        {submittedRequest.verification_status === "not_received" && submittedRequest.send_type === "phone_number" && <p>Chưa nhận xác thực. Vui lòng gửi từ số điện thoại đã liên kết.</p>}
                        {submittedRequest.verification_status === "invalid" && <p>Xác thực không hợp lệ. Vui lòng kiểm tra thông tin và gửi lại.</p>}
                      </div>}
                      {pollingChecks >= 15 && submittedRequest.status === "no_process" && <div className="request-processing-actions">
                        <button type="button" disabled={isRefreshingRequest} onClick={refreshSubmittedRequest}>{isRefreshingRequest ? "Đang kiểm tra..." : "Kiểm tra lại"}</button>
                        <button type="button" onClick={copySubmittedRequestCode}>Sao chép mã</button>
                        <a href={webSetting.link_cskh} target="_blank" rel="noopener noreferrer">Liên hệ CSKH</a>
                      </div>}
                      {requestRefreshMessage && <p className="request-refresh-message" role="status">{requestRefreshMessage}</p>}
                    </div>
                  )}
                  <div className="notification">
                    <p
                      style={{
                        color: "#F7B922",
                        padding: "3px 0px",
                        margin: "0px",
                      }}
                    >
                      Lưu ý:
                    </p>
                    <p>
                      - Liên hệ{" "}
                      <a
                        href={webSetting.link_cskh}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        CSKH
                      </a>{" "}
                      nếu cần hỗ trợ thêm.
                    </p>
                  </div>
                </div>
            </motion.div>
          </Popup>
          <Popup
            open={openResult}
            onClose={() => setOpenResult(false)}
            position={"center"}
          >
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="modal-success"
            >
              <div className="modal-close">
                <a className="icon-close" onClick={() => setOpenResult(false)}>
                  <img src={iconClose} alt="icon-close" />
                </a>
              </div>
              {checkConfirm ? (
                <div className="modal-result-content">
                  <img
                    style={{ marginBottom: "20px" }}
                    src={iconSuccess}
                    alt="icon-success"
                  />
                  <span>
                    Chúng tôi đã nhận được yêu cầu của Quý khách.
                  </span>
                </div>
              ) : (
                <div className="modal-result-content">
                  <img
                    style={{ marginBottom: "20px" }}
                    src={iconWarning}
                    alt="icon-success"
                  />
                  <span>
                    Yêu cầu của bạn chưa được ghi nhận, vui lòng thử lại hoặc
                    liên hệ chăm sóc khách hàng
                  </span>
                </div>
              )}
            </motion.div>
          </Popup>
          <Popup
            open={openUploadFile}
            onClose={() => setOpenUploadFile(false)}
            position={"center"}
          >
            {/* <motion.div initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="modal-success">
              <div className="modal-close">
                <a className="icon-close" onClick={() => setOpenUploadFile(false)}>
                  <img src={iconClose} alt="icon-close" />
                </a>
              </div>
                <div className="modal-result-content">
                  <img style={{ marginBottom: "20px" }} src={iconWarning} alt="icon-success"/>
                  <span>Bạn cần cung cấp thêm hình ảnh để xác minh thông tin.</span>
                  
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    sx={{
                      color: "black",
                      marginBottom: "-10px",
                      marginTop: "-15px",
                      fontWeight: "bold",
                    }}
                  >
                    <div className='upload-file' dangerouslySetInnerHTML={{ __html: infoFileUpload }}/>
                  </Typography>
                  <Box
                    display="flex"
                    alignItems="center"
                    marginY={1}
                    flexWrap="wrap"
                    gap="8px 8px"
                  >
                    {previews.map((preview, index) => (
                      <Box
                        onClick={() => handleRemoveImage(index)}
                        key={index}
                        sx={{
                          maxHeight: 80,
                          maxWidth: 90,
                          width: "auto",
                          height: "auto",
                          position: "relative",
                          overflow: "hidden",
                          cursor: "pointer",
                          "&:hover .delete-button": {
                            display: "block",
                          },
                        }}
                      >
                        <img
                          src={preview}
                          alt={`preview-${index}`}
                          style={{
                            width: "auto",
                            maxWidth: "100%",
                            height: "auto",
                            maxHeight: "100%",
                            borderRadius: 4,
                            objectFit: "cover",
                          }}
                        />
                        <IconButton
                          className="delete-button"
                          sx={{
                            position: "absolute",
                            top: 0,
                            right: 0,
                            color: "red",
                            p: 0,
                          }}
                        >
                          <Close fontSize="small" />
                        </IconButton>
                      </Box>
                    ))}
                    
                    <Box>
                    <input
                      accept="image/*"
                      style={{ display: "none" }}
                      id="upload-button"
                      type="file"
                      onChange={handleImageUpload}
                      multiple
                    />
                    <label htmlFor="upload-button">
                      <Button
                        variant="text"
                        component="span"
                        sx={{
                          width: "90px",
                          height: "80px",
                          color: "#6BB0C8",
                          borderColor: "#6BB0C8",
                          borderStyle: "solid",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          "&:hover": {
                            borderColor: "#6BB0C8",
                            color: "#6BB0C8",
                            transform: "scale(1.05)", // thêm zoom nhẹ
                          },
                          transition: "all 0.3s ease",
                        }}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 71 70" fill="none">
                          <path d="M15.1375 1.3252C27.8543 0.60654 40.5997 0.561587 53.3201 1.19043L55.863 1.3252H55.864C59.114 1.50811 62.1944 2.80657 64.5896 4.99121L65.0593 5.44043C67.361 7.74221 68.7922 10.7632 69.1228 13.9883L69.1746 14.6357C69.8932 27.3528 69.9381 40.0988 69.3093 52.8193L69.1746 55.3623V55.3633C68.9916 58.6134 67.6923 61.6936 65.5076 64.0889L65.0593 64.5586C62.7577 66.8603 59.7365 68.2915 56.5115 68.6221L55.864 68.6738H55.863C43.1465 69.3942 30.4015 69.4389 17.6814 68.8086L15.1375 68.6738C11.8872 68.491 8.80643 67.1917 6.41089 65.0068L5.94116 64.5586C3.63936 62.2568 2.20761 59.2358 1.87671 56.0107L1.82593 55.3633V55.3623C1.1073 42.6455 1.06234 29.9001 1.69116 17.1797L1.82593 14.6357C2.00902 11.3856 3.3081 8.30551 5.49292 5.91016L5.94116 5.44043C8.24317 3.13853 11.2646 1.7066 14.49 1.37598L15.1375 1.3252Z" fill="url(#paint0_linear)" stroke="#13AFF1" strokeWidth="1.5"/>
                          <path d="M17.2089 18.8681V12.3867H21.5298V18.8681H28.0112V23.189H21.5298V29.6703H17.2089V23.189H10.7275V18.8681H17.2089ZM23.6903 31.8308V25.3494H30.1716V18.8681H45.2948L49.2484 23.189H56.097C58.4735 23.189 60.4179 25.1334 60.4179 27.5099V53.4353C60.4179 55.8118 58.4735 57.7562 56.097 57.7562H21.5298C19.1533 57.7562 17.2089 55.8118 17.2089 53.4353V31.8308H23.6903ZM38.8134 51.2749C44.7763 51.2749 49.6157 46.4354 49.6157 40.4726C49.6157 34.5097 44.7763 29.6703 38.8134 29.6703C32.8506 29.6703 28.0112 34.5097 28.0112 40.4726C28.0112 46.4354 32.8506 51.2749 38.8134 51.2749ZM31.9 40.4726C31.9 44.2966 34.9894 47.386 38.8134 47.386C42.6374 47.386 45.7269 44.2966 45.7269 40.4726C45.7269 36.6486 42.6374 33.5591 38.8134 33.5591C34.9894 33.5591 31.9 36.6486 31.9 40.4726Z" fill="url(#paint1_linear)"/>
                          <defs>
                            <linearGradient id="paint0_linear" x1="35.4999" y1="-0.270795" x2="35.4999" y2="68.7699" gradientUnits="userSpaceOnUse">
                              <stop stopColor="#E8F5FF"/>
                              <stop offset="1" stopColor="#B4DFFF"/>
                            </linearGradient>
                            <linearGradient id="paint1_linear" x1="35.5727" y1="12.3867" x2="35.5727" y2="57.7562" gradientUnits="userSpaceOnUse">
                              <stop stopColor="#466AFF"/>
                              <stop offset="1" stopColor="#06B8FF"/>
                            </linearGradient>
                          </defs>
                        </svg>
                      </Button>
                    </label>
                  </Box>
                  </Box>
                  <Typography variant="caption">
                    Cung cấp hình ảnh đúng mô tả để được xét duyệt
                  </Typography>
                  {selectedImage.length >= 2 ? (
                    <div>
                      <button id="complete_files_btn" onClick={() => {setOpenUploadFile(false); updateUser(user.send_type)}}>
                        XÁC NHẬN
                      </button>
                    </div>
                  ) : 
                    <div>
                    <button id="complete_files_btn_disable">
                    </button>
                  </div>
                  }
                </div>
            </motion.div> */}

            <motion.div
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="modal-success"
            >
              <div className="modal-close">
                <a
                  className="icon-close"
                  onClick={() => setOpenUploadFile(false)}
                >
                  <img src={iconClose} alt="icon-close" />
                </a>
              </div>
              <div className="modal-result-content">
                <img
                  style={{ marginBottom: "20px" }}
                  src={iconWarning}
                  alt="icon-success"
                />
                <span>
                  Bạn cần cung cấp thêm hình ảnh để xác minh thông tin.
                </span>

                <Typography
                  variant="body2"
                  color="textSecondary"
                  sx={{
                    color: "black",
                    marginBottom: "-10px",
                    marginTop: "-15px",
                    fontWeight: "bold",
                  }}
                >
                  <div
                    className="upload-file"
                    dangerouslySetInnerHTML={{ __html: infoFileUpload }}
                  />
                </Typography>

                <Box
                  display="flex"
                  alignItems="center"
                  marginY={1}
                  flexWrap="wrap"
                  gap="8px 8px"
                >
                  {previews.map((preview, index) => (
                    <Box
                      onClick={() => handleRemoveImage(index)}
                      key={index}
                      sx={{
                        maxHeight: 80,
                        maxWidth: 90,
                        width: "auto",
                        height: "auto",
                        position: "relative",
                        overflow: "hidden",
                        cursor: "pointer",
                        "&:hover .delete-button": {
                          display: "block",
                        },
                      }}
                    >
                      {preview.type.startsWith("image/") ? (
                        <img
                          src={preview.url}
                          alt={`preview-${index}`}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: 4,
                          }}
                        />
                      ) : (
                        <video
                          src={preview.url}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: 4,
                          }}
                          controls
                        />
                      )}

                      <IconButton
                        className="delete-button"
                        sx={{
                          position: "absolute",
                          top: 0,
                          right: 0,
                          color: "red",
                          p: 0,
                        }}
                      >
                        <Close fontSize="small" />
                      </IconButton>
                    </Box>
                  ))}

                  <Box>
                    <input
                      accept="image/*,video/*"
                      style={{ display: "none" }}
                      id="upload-button"
                      type="file"
                      onChange={handleImageUpload}
                      multiple
                    />
                    <label htmlFor="upload-button">
                      <Button
                        variant="text"
                        component="span"
                        sx={{
                          width: "90px",
                          height: "80px",
                          color: "#6BB0C8",
                          borderColor: "#6BB0C8",
                          borderStyle: "solid",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          "&:hover": {
                            borderColor: "#6BB0C8",
                            color: "#6BB0C8",
                            transform: "scale(1.05)",
                          },
                          transition: "all 0.3s ease",
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="50"
                          height="50"
                          viewBox="0 0 71 70"
                          fill="none"
                        >
                          <path
                            d="M15.1375 1.3252C27.8543 0.60654 40.5997 0.561587 53.3201 1.19043L55.863 1.3252H55.864C59.114 1.50811 62.1944 2.80657 64.5896 4.99121L65.0593 5.44043C67.361 7.74221 68.7922 10.7632 69.1228 13.9883L69.1746 14.6357C69.8932 27.3528 69.9381 40.0988 69.3093 52.8193L69.1746 55.3623V55.3633C68.9916 58.6134 67.6923 61.6936 65.5076 64.0889L65.0593 64.5586C62.7577 66.8603 59.7365 68.2915 56.5115 68.6221L55.864 68.6738H55.863C43.1465 69.3942 30.4015 69.4389 17.6814 68.8086L15.1375 68.6738C11.8872 68.491 8.80643 67.1917 6.41089 65.0068L5.94116 64.5586C3.63936 62.2568 2.20761 59.2358 1.87671 56.0107L1.82593 55.3633V55.3623C1.1073 42.6455 1.06234 29.9001 1.69116 17.1797L1.82593 14.6357C2.00902 11.3856 3.3081 8.30551 5.49292 5.91016L5.94116 5.44043C8.24317 3.13853 11.2646 1.7066 14.49 1.37598L15.1375 1.3252Z"
                            fill="url(#paint0_linear)"
                            stroke="#13AFF1"
                            strokeWidth="1.5"
                          />
                          <path
                            d="M17.2089 18.8681V12.3867H21.5298V18.8681H28.0112V23.189H21.5298V29.6703H17.2089V23.189H10.7275V18.8681H17.2089ZM23.6903 31.8308V25.3494H30.1716V18.8681H45.2948L49.2484 23.189H56.097C58.4735 23.189 60.4179 25.1334 60.4179 27.5099V53.4353C60.4179 55.8118 58.4735 57.7562 56.097 57.7562H21.5298C19.1533 57.7562 17.2089 55.8118 17.2089 53.4353V31.8308H23.6903ZM38.8134 51.2749C44.7763 51.2749 49.6157 46.4354 49.6157 40.4726C49.6157 34.5097 44.7763 29.6703 38.8134 29.6703C32.8506 29.6703 28.0112 34.5097 28.0112 40.4726C28.0112 46.4354 32.8506 51.2749 38.8134 51.2749ZM31.9 40.4726C31.9 44.2966 34.9894 47.386 38.8134 47.386C42.6374 47.386 45.7269 44.2966 45.7269 40.4726C45.7269 36.6486 42.6374 33.5591 38.8134 33.5591C34.9894 33.5591 31.9 36.6486 31.9 40.4726Z"
                            fill="url(#paint1_linear)"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear"
                              x1="35.4999"
                              y1="-0.270795"
                              x2="35.4999"
                              y2="68.7699"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="#E8F5FF" />
                              <stop offset="1" stopColor="#B4DFFF" />
                            </linearGradient>
                            <linearGradient
                              id="paint1_linear"
                              x1="35.5727"
                              y1="12.3867"
                              x2="35.5727"
                              y2="57.7562"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="#466AFF" />
                              <stop offset="1" stopColor="#06B8FF" />
                            </linearGradient>
                          </defs>
                        </svg>
                      </Button>
                    </label>
                  </Box>
                </Box>

                <Typography variant="caption" sx={{ color: "#B0B3C1" }}>
                  Cung cấp hình ảnh đúng theo mô tả để được xét duyệt
                </Typography>

                {selectedImage.length >= minFiles && (
                  <div>
                    <button
                      id="complete_files_btn"
                      onClick={() => {
                        setOpenUploadFile(false);
                        updateUser(user.send_type);
                      }}
                    >
                      Hoàn thành xác minh
                    </button>
                  </div>
                )}
              </div>
            </motion.div>
          </Popup>
        </div>
      </motion.div>
    </div>
  );
}

export default ChangeInfo;
